export default {
  links: {
    home: "ADISA",
    equipment: "Обладнання",
    info: "Документація",
    contacts: "Контакти"
  }
};
